import { useSyncExternalStore } from 'react';

function subscribe(onChange: () => void): () => void {
  window.addEventListener('online', onChange);
  window.addEventListener('offline', onChange);
  return () => {
    window.removeEventListener('online', onChange);
    window.removeEventListener('offline', onChange);
  };
}

/** Browser connectivity is a UI hint; actual request failures stay authoritative. */
export function useNetworkOnline(): boolean {
  return useSyncExternalStore(subscribe, () => navigator.onLine, () => true);
}
